/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set severity`)
};

const es_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir gravedad`)
};

const de_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schweregrad festlegen`)
};

const nl_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ernst instellen`)
};

const fr_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définir la gravité`)
};

const it_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta gravità`)
};

const pt_br2_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir gravidade`)
};

const pt_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir gravidade`)
};

const ja_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重大度を設定`)
};

const zh_admin_set_severity = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置严重程度`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const admin_set_severity = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.admin_set_severity(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("admin_set_severity", locale)
	if (locale === "en") return en_admin_set_severity(inputs)
	if (locale === "es") return es_admin_set_severity(inputs)
	if (locale === "de") return de_admin_set_severity(inputs)
	if (locale === "nl") return nl_admin_set_severity(inputs)
	if (locale === "fr") return fr_admin_set_severity(inputs)
	if (locale === "it") return it_admin_set_severity(inputs)
	if (locale === "pt-BR") return pt_br2_admin_set_severity(inputs)
	if (locale === "pt") return pt_admin_set_severity(inputs)
	if (locale === "ja") return ja_admin_set_severity(inputs)
	return zh_admin_set_severity(inputs)
};